import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchArticleCategories, fetchArticlesByCategories } from "../../../api/articles";

const ClockIcon = () => (
    <svg className="w-3.5 h-3.5 mr-1 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const ArticlesFilterPage = () => {
    const { id } = useParams();
    const [articles, setArticles] = useState();
    const [categories, setCategories] = useState();

    const fetchArticles = async () => {
        const _articles = await fetchArticlesByCategories(id);
        if (_articles != null) {
            setArticles(_articles.articles);
        }
    }

    const fetchCategories = async () => {
        const fetchCategory = await fetchArticleCategories();
        if (fetchCategory != null) {
            setCategories(fetchCategory);
        }
    }

    useEffect(() => {
        fetchCategories();
        fetchArticles();
    }, [id]);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="space-y-8">
                {/* Header */}
                <div className="space-y-4">
                    <h1 className="text-2xl font-bold text-slate-800 tracking-tight">Статьи и новости</h1>
                    
                    {/* Categories scroll */}
                    <div className="w-full overflow-x-auto pb-2">
                        {categories != null && (
                            <nav className="flex space-x-3 min-w-max">
                                <Link
                                    to="/articles"
                                    className="px-4 py-1.5 text-sm font-semibold bg-slate-50 text-slate-600 rounded-full hover:bg-blue-50 hover:text-blue-600 border border-slate-100 hover:border-blue-100 transition-colors"
                                >
                                    Все категории
                                </Link>
                                {categories.map((category) => {
                                    const isActive = id === String(category.id);
                                    return (
                                        <Link
                                            key={category.id}
                                            to={`/articles_categories/${category.id}`}
                                            className={`px-4 py-1.5 text-sm font-semibold rounded-full border transition-colors ${
                                                isActive
                                                    ? "bg-blue-600 text-white border-blue-600"
                                                    : "bg-slate-50 text-slate-600 border-slate-100 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-100"
                                            }`}
                                        >
                                            {category.name}
                                        </Link>
                                    );
                                })}
                            </nav>
                        )}
                    </div>
                </div>

                {/* Articles Grid */}
                {articles ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        {articles.map((article) => (
                            <Link
                                key={article.id}
                                to={`/article/${article.id}`}
                                className="group no-underline block h-full"
                            >
                                <article className="bg-white rounded-2xl border border-slate-100 hover:border-blue-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 overflow-hidden h-full flex flex-col">
                                    {/* Image */}
                                    <div className="w-full h-[170px] overflow-hidden bg-slate-50 relative">
                                        <img
                                            src={article.image}
                                            alt={article.title}
                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                        />
                                    </div>

                                    {/* Content */}
                                    <div className="flex flex-col flex-grow p-4 space-y-3">
                                        <h3 className="text-slate-800 font-semibold text-[15px] group-hover:text-blue-600 transition-colors line-clamp-2">
                                            {article.title}
                                        </h3>
                                        
                                        <div
                                            className="text-slate-500 text-xs leading-relaxed line-clamp-3"
                                            dangerouslySetInnerHTML={{
                                                __html: article.text
                                            }}
                                        />

                                        <div className="flex items-center text-slate-400 text-[11px] mt-auto pt-3 border-t border-slate-50">
                                            <ClockIcon />
                                            <span>Сегодня 13:01</span>
                                        </div>
                                    </div>
                                </article>
                            </Link>
                        ))}
                    </div>
                ) : (
                    <div className="flex justify-center items-center py-12">
                        <div className="text-slate-500 text-sm">
                            Загрузка статей...
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ArticlesFilterPage;